module.exports = __webpack_public_path__ + "img/REN.23f8b596.svg";